import productReviewAddHtml from './productreviewadd.component.html';

class ProductReviewAddController {
    constructor($scope, $http, $window, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.SnackbarService = SnackbarService;

        this.productName = null;
        this.loading = false;
        this.showAllErrors = false;

        this.dataRatingError = false;

        this.data = {
            from: '',
            email: '',
            rating: null,
            content: ''
        };

        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.dataValidations = {
            from: () => this.userIsLoggedIn === 1 || this.data.from !== '',
            email: () => this.userIsLoggedIn === 1 || this.data.email === '' || emailRegex.test(String(this.data.email).toLowerCase()),
            rating: () => this.dataRatingError === false,
            content: () => this.data.content !== ''
        };
    }

    isValid() {
        for (const validatorFnName in this.dataValidations) {
            if (!this.dataValidations[validatorFnName]()) return false;
        }

        return true;
    }

    $onInit() {
        this.data.productId = this.productId;
        this.setRating(5);
    }

    setRating(rating) {
        this.data.rating = rating;
        this.dataRatingError = false;
    }

    save() {
        this.showAllErrors = true;

        if (this.data.rating === null || parseInt(this.data.rating) < 1 || parseInt(this.data.rating) > 5) {
            this.dataRatingError = true;
        }

        if (!this.isValid()) return;

        this.loading = true;

        this.$http.post(
            '/ajax/products/productReview',
            this.data
        ).then(
            (response) => {
                this.loading = false;

                this.$scope.$parent.$ctrl.close();

                this.SnackbarService.add(response.data.message.content, response.data.message.type, true, 3000);

                if (response.data.message.reload === 'true') {
                    const _thisWindow = this.$window;
                    setTimeout(function () {
                        _thisWindow.location.reload();
                    }, 2000);
                }
            },
            (error) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
            }
        );
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let productReviewAddComponent = {
    bindings: {
        productId: '<',
        productName: '@',
        userIsLoggedIn: '<'
    },
    template: productReviewAddHtml,
    controller: ProductReviewAddController
};

export default productReviewAddComponent;
